import {
  HttpPutRequestModel,
  HttpRequestModelType,
  __HttpRequestModel__,
} from 'shared/domain/httpRequest/httpRequestModel';
import type { ProcessType } from 'shared/domain/process/types/model';
import {
  IProcessUploader,
  UploadProcessWorkflowChange,
} from 'serviceWorker/repository/process/uploadProcess';
import type { IHttpRequestRunner } from 'shared/domain/httpRequest/httpRequestRunner';

export interface ProcessWorkflowUpdateRequestData {
  processId: string;
  workflowId: string;
  projectId: string;
  uniqueId: string;
}

export type ProcessWorkflowUpdateRequestModel = HttpPutRequestModel<
  ProcessWorkflowUpdateRequestData,
  HttpRequestModelType.process
>;

export class ProcessRequestRunner implements IHttpRequestRunner {
  constructor(
    private processUploader: IProcessUploader,
    private uploadProcessWorkflowChangeUseCase: UploadProcessWorkflowChange
  ) {}

  async execute(
    request: __HttpRequestModel__ | ProcessWorkflowUpdateRequestModel
  ): Promise<ProcessType> {
    switch (request.method) {
      case 'PUT': {
        return this.uploadProcessWorkflowChange(
          request as ProcessWorkflowUpdateRequestModel
        );
      }
      default: {
        throw new Error(`Unsupported method for process: ${request.method}`);
      }
    }
  }

  private async uploadProcessWorkflowChange(
    request: ProcessWorkflowUpdateRequestModel
  ): Promise<ProcessType> {
    return this.uploadProcessWorkflowChangeUseCase(
      this.processUploader,
      request.data.workflowId,
      request.url
    );
  }
}
